// eslint-disable-next-line import/prefer-default-export
export const ComparablesFilterType = {
  Lat: 'lat',
  Lng: 'lng',
  Parking: 'parking',
  Style: 'style',
};
